angular.module('lsnBase.filters')
  .filter('join', function(){
    return function(textArray, glue) {
      textArray = angular.isArray(textArray) ? textArray : [];
      return textArray.join(glue);
    };
});